import {
  FETCH_COMMENTS,
  UPDATE_ADD_COMMENT_ERROR,
  UPDATE_ADD_REPLY_ERROR,
  UPDATE_ADD_REPLY_ID,
  UPDATE_COMMENTS,
  UPDATE_COMMENT_BUCKETS,
  UPDATE_COMMENT_REPLY_COUNT,
  UPDATE_EXPANDED_REPLY_IDS,
  UPDATE_FETCHING_COMMENTS_ERROR,
  UPDATE_IS_FETCHING,
} from 'constants/actions';

export const fetchComments = () => {
  return { type: FETCH_COMMENTS };
};

export const updateAddReplyError = err => {
  return {
    type: UPDATE_ADD_REPLY_ERROR,
    err,
  };
};

export const updateAddCommentError = err => {
  return {
    type: UPDATE_ADD_COMMENT_ERROR,
    err,
  };
};

export const updateAddReplyId = addReplyId => {
  return { type: UPDATE_ADD_REPLY_ID, addReplyId };
};

export const updateComments = comments => {
  return { type: UPDATE_COMMENTS, comments };
};

export const updateExpandedReplyIds = expandedIds => {
  return { type: UPDATE_EXPANDED_REPLY_IDS, expandedIds };
};

export const updateFetchingCommentsError = fetchingError => {
  return { type: UPDATE_FETCHING_COMMENTS_ERROR, fetchingError };
};

export const updateIsFetching = isFetching => {
  return { type: UPDATE_IS_FETCHING, isFetching };
};

export const updateCommentBuckets = (commentBuckets, commentReplyCount) => {
  return { type: UPDATE_COMMENT_BUCKETS, commentBuckets, commentReplyCount };
};

export const updateCommentReplyCount = commentReplyCount => {
  return { type: UPDATE_COMMENT_REPLY_COUNT, commentReplyCount };
};
